import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

/**
 * Reusable Base Modal Component
 * - Mobile-friendly with proper viewport handling
 * - Scrollable content area
 * - Customizable size and styling
 */
const BaseModal = ({ 
  isOpen, 
  onClose, 
  children, 
  maxWidth = 'max-w-4xl',
  showCloseButton = true,
  closeButtonClass = ''
}) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-black/80 backdrop-blur-sm overflow-y-auto"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className={`glass-strong rounded-3xl p-6 sm:p-8 w-full ${maxWidth} my-auto relative`}
          style={{ 
            maxHeight: 'calc(100vh - 2rem)',
            overflowY: 'auto'
          }}
        >
          {/* Close Button */}
          {showCloseButton && (
            <button
              onClick={onClose}
              className={`absolute top-4 right-4 sm:top-6 sm:right-6 text-white/60 hover:text-white transition-colors z-10 p-2 ${closeButtonClass}`}
              aria-label="Close modal"
            >
              <FaTimes size={24} />
            </button>
          )}

          {/* Modal Content */}
          <div className="relative">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default BaseModal;
